import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-[#1C2B3A]">
      {/* Background image - very subtle */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9e1aa9a4a33fbe162531a42a5167e306.jpg"
          alt=""
          className="w-full h-full object-cover object-center opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1C2B3A]/98 via-[#1C2B3A]/85 to-[#1C2B3A]/55" />
      </div>

      {/* Content: centered split layout */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 md:px-16 pt-28 pb-16 flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

        {/* LEFT: Text Content */}
        <div
          className={`flex-1 min-w-0 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Badge */}
          <div className="inline-flex items-center gap-3 border border-white/20 bg-white/8 backdrop-blur-sm text-white/75 text-sm font-medium px-5 py-2.5 rounded-full mb-10">
            <span className="w-2 h-2 rounded-full bg-[#E8521A] animate-pulse inline-block" />
            AI-Powered Geotechnical Analysis &amp; Smart Monitoring
          </div>

          {/* Main Headline */}
          <h1
            className="text-5xl md:text-6xl lg:text-[64px] font-black text-white leading-[1.1] tracking-tight mb-8"
            style={{ fontFamily: "'Noto Sans KR', sans-serif", letterSpacing: '-0.03em' }}
          >
            <span className="text-[#E8521A]">AI 기반</span><br />
            지반 데이터 분석 및<br />
            <span className="text-[#E8521A]">스마트 계측</span><br />
            전문기업
          </h1>

          {/* Divider */}
          <div className="mb-8">
            <span className="block w-16 h-1 bg-[#E8521A] rounded-full" />
          </div>

          {/* Sub Description */}
          <p
            className="text-white/75 text-lg md:text-xl leading-relaxed max-w-xl mb-12"
            style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
          >
            지반조사, 계측, 정밀안전진단 데이터를 기반으로<br />
            <strong className="text-white font-semibold">생성형 AI 및 데이터 분석</strong> 기술을 활용하여<br />
            정확한 해석과 <strong className="text-white font-semibold">신뢰성 있는 의사결정</strong>을 지원합니다
          </p>

          {/* CTA Buttons */}
          <div
            className={`flex flex-col sm:flex-row items-start gap-4 transition-all duration-700 delay-300 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <Link
              to="/solution"
              className="group inline-flex items-center gap-3 bg-[#E8521A] text-white font-bold text-lg px-10 py-5 rounded-full hover:bg-[#d04515] transition-all duration-200 whitespace-nowrap"
            >
              솔루션 보기
              <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
            <Link
              to="/contact"
              className="group inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white font-bold text-lg px-10 py-5 rounded-full hover:bg-white/20 hover:border-white/50 transition-all duration-200 whitespace-nowrap"
            >
              <i className="ri-mail-send-line" />
              견적 의뢰하기
            </Link>
          </div>
        </div>

        {/* RIGHT: Photo */}
        <div
          className={`flex-shrink-0 w-full lg:w-[500px] xl:w-[540px] transition-all duration-1000 delay-400 ${
            visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'
          }`}
        >
          <div className="relative rounded-2xl overflow-hidden" style={{ height: '540px' }}>
            <img
              src="https://readdy.ai/api/search-image?query=professional%20geotechnical%20engineer%20operating%20ground%20drilling%20equipment%20on%20construction%20site%2C%20soil%20investigation%20borehole%20drilling%20machine%2C%20workers%20in%20safety%20helmets%20and%20vests%2C%20measuring%20instruments%20and%20sensors%20installed%20in%20ground%2C%20civil%20engineering%20fieldwork%2C%20realistic%20photography%2C%20natural%20daylight%2C%20clean%20simple%20background&width=540&height=540&seq=hero-right-geo-v5&orientation=squarish"
              alt="지반 계측 현장"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1C2B3A]/40 via-transparent to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-l from-transparent via-transparent to-[#1C2B3A]/20" />
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/35">
        <span className="text-xs tracking-widest uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>Scroll</span>
        <i className="ri-arrow-down-line text-lg animate-bounce" />
      </div>
    </section>
  );
};

export default HeroSection;
